@if ((!isCompoundFieldMember) && !(lmColumnLayoutInfo?.isTable && isFormText && !lmParagraphLayoutInfo?.parentIsParagraphLayout)) {
    <label
        soho-label
        [required]="required$ | async"
        [attr.for]="id"
        lm-label
        [layoutField] = "field"
        [lmColumnLayoutInfo]="lmColumnLayoutInfo"
        [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
        [layoutInfo]="layoutInfo"
        [personalize]="personalize && !field?.label?.textStyle?.color"
        [isCompoundFieldMember]="isCompoundFieldMember"
        lm-text-style
        [textStyle]="field?.label?.textStyle"
        [recalculateStyles]="triggerValueChange | async"
    >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
    </label>
}
@switch (formType) {
    @case (formDisplayType.SEARCH_FORM) {
        @if (isCompoundFieldMember) {
            @switch (displayType) {

                @case (layoutDisplayType.PLAIN) {
                    <input
                       #Input
                       [ngClass]="fieldClassesString"
                       [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                       [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
                       lm-displayupper [isUpperCase]="isUpperCase"
                       lm-field-style [specField]="specField" [recalculateStyles]="triggerValueChange | async"
                       soho-alert
                       [attr.id]="id"
                       [attr.bindId]="bindId"
                       [attr.type]="type"
                       [attr.maxlength]="maxLength"
                       [attr.size]="size"
                       [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                       (ngModelChange)="onNgModelChange($event)"
                       (blur)="onBlur($event)"
                    />
                }

                @case (layoutDisplayType.MASK) {
                    <input
                       #Input
                       [ngClass]="fieldClassesString"
                       [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                       lm-field-style [specField]="specField" [recalculateStyles]="triggerValueChange | async"
                       soho-input [fireInputEventKludge]="false"
                       soho-mask [options]="maskOptions"
                       soho-alert
                       [attr.id]="id"
                       [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
                       [attr.bindId]="bindId"
                       [attr.type]="type"
                       [attr.size]="size"
                       [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                       (ngModelChange)="onNgModelChange($event)"
                       (blur)="onBlur($event)"
                    />
                }
            }

            @if (isCompoundFieldMember) {
                @if(isPreviewCompoundMember) {
                    <ng-container *ngTemplateOutlet="previewMode"></ng-container>
                } @else {
                    <ng-container *ngTemplateOutlet="normalMode"></ng-container>
                }
            }

        } @else {
            @switch (displayType) {
                @case (layoutDisplayType.PLAIN) {
                    @if (transformOptions.allowMultiSelections) {
                        <input
                            #Input
                            [ngClass]="fieldClassesString"
                            [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                            [attr.id]="id"
                            [attr.bindId]="bindId"
                            [attr.type]="type"
                            [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                            (ngModelChange)="onNgModelChange($event)"
                            soho-alert
                            lm-displayupper
                            [isUpperCase]="isUpperCase"
                            lm-field-style
                            [specField]="specField"
                            [recalculateStyles]="triggerValueChange | async"
                            soho-tooltip content="{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions}}"
                            soho-field-filter
                            [fieldDropdownDataSet]="filterSettings"
                            [selectedFilterType]="triggerValueChange | async | toFieldOperator : modelField : 'contains'"
                            (filtered)="onFiltered($event)"
                            (blur)="onBlur($event)"
                            (keypress)="onSearchKeypress($event)"
                            [attr.aria-describedby]="fieldDescriptionId" 
                        />
                    } @else {
                        <input
                            #Input
                            [ngClass]="fieldClassesString"
                            [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                            [attr.id]="id"
                            [attr.bindId]="bindId"
                            [attr.type]="type"
                            [attr.maxlength]="maxLength"
                            [attr.size]="size"
                            [attr.aria-describedby]="fieldDescriptionId" 
                            [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                            (ngModelChange)="onNgModelChange($event)"
                            soho-alert
                            lm-displayupper
                            [isUpperCase]="isUpperCase"
                            lm-field-style
                            [specField]="specField"
                            [recalculateStyles]="triggerValueChange | async"
                            soho-tooltip content="{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions}}"
                            soho-field-filter
                            [fieldDropdownDataSet]="filterSettings"
                            [selectedFilterType]="triggerValueChange | async | toFieldOperator : modelField : 'contains'"
                            (filtered)="onFiltered($event)"
                            (blur)="onBlur($event)"
                            (keypress)="onSearchKeypress($event)"
                        />
                    }
                }
                @case (layoutDisplayType.MASK) {
                    @if (transformOptions.allowMultiSelections) {
                        <input
                            #Input
                            [ngClass]="fieldClassesString"
                            class="maskedSearchForm"
                            [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                            [attr.id]="id"
                            [attr.bindId]="bindId"
                            [attr.type]="type"
                            [attr.aria-describedby]="fieldDescriptionId" 
                            [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                            (ngModelChange)="onNgModelChange($event)"
                            soho-alert
                            lm-field-style
                            [specField]="specField"
                            [recalculateStyles]="triggerValueChange | async"
                            soho-input
                            [fireInputEventKludge]="false"
                            soho-mask
                            [options]="searchFieldMaskOptions"
                            soho-tooltip content="{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions}}"
                            soho-field-filter
                            [fieldDropdownDataSet]="filterSettings"
                            [selectedFilterType]="triggerValueChange | async | toFieldOperator : modelField"
                            (filtered)="onFiltered($event)"
                            (blur)="onBlur($event)"
                            (keypress)="onSearchKeypress($event)"
                        />
                    } @else {
                        <input
                            #Input
                            [ngClass]="fieldClassesString"
                            [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                            [attr.id]="id"
                            [attr.bindId]="bindId"
                            [attr.type]="type"
                            [attr.size]="size"
                            [attr.aria-describedby]="fieldDescriptionId" 
                            [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                            (ngModelChange)="onNgModelChange($event)"
                            soho-alert
                            lm-field-style
                            [specField]="specField"
                            [recalculateStyles]="triggerValueChange | async"
                            soho-input
                            [fireInputEventKludge]="false"
                            soho-mask
                            [options]="maskOptions"
                            soho-tooltip content="{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions}}"
                            soho-field-filter
                            [fieldDropdownDataSet]="filterSettings"
                            [selectedFilterType]="triggerValueChange | async | toFieldOperator : modelField"
                            (filtered)="onFiltered($event)"
                            (blur)="onBlur($event)"
                            (keypress)="onSearchKeypress($event)"
                        />
                    }
                }

                @case (layoutDisplayType.PLAIN_FORM_TEXT) {
                    @if (layoutObject.icon) {
                        @if (validSohoIcon) {
                            <svg
                                class="icon"
                                focusable="false"
                                aria-hidden="true"
                                role="presentation"
                            >
                                <use [attr.xlink:href]="'#icon-' +  layoutObject.icon + ''"></use>
                            </svg>
                        } @else {
                            <img class="icon" src="{{iconUrl}}" alt="">
                        }
                    }
                    @switch (hasRichTextVars) {
                        @case (true) {
                            <div class="editor-container is-preview field">
                                <div
                                    class="lm-richtext-content is-preview hide-white-space"
                                    [ngClass]="fieldClassesString"
                                    data-options="{preview: true}"
                                    [innerHTML]="triggerValueChange | async | formatMessageRule:true:field.text:model:specFields"
                                    [attr.name]="id"
                                    [attr.id]="id"
                                    [attr.bindId]="bindId"
                                    soho-editor
                                    soho-alert
                                ></div>
                            </div>
                        }
                        @case (false) {
                            <p
                               [attr.id]="id"
                               class="lm-form-text hide-white-space"
                               [class.personalize-text]="personalize && !layoutObject?.textStyle?.color"
                               [class.data]="true"
                               lm-text-style
                               [textStyle]="layoutObject?.textStyle"
                               [recalculateStyles]="triggerValueChange | async"
                            >{{triggerValueChange | async | formatMessageRule:true:field.text:model:specFields}}</p>
                        }
                    }
                }
            }
            @if (layoutInfo.isAdHoc) {
                <button
                    id="AdHocRemove"
                    class="lm-compound-field-dialog-button lm-adhoc-remove"
                    soho-button="icon"
                    [icon]="'close-small'"
                    soho-tooltip
                    [content]="'Remove Field'"
                    (click)="removeAdHocField($event)"
                ></button>
            }
        }
    }
    @default {
        <div
            [ngClass]="{
                'disabled-member-field': disabledMemberField,
                'lm-is-display-as-tag': displayAsTag,
                'lm-is-display-as-text': displayAsText,
                'lm-is-compact-format': field.type === 'compactFormat'
             }"
            lm-field-options
                [hasContextMenu]="hasContextMenu$ | async"
                [ajaxCallbackFunction]="onBeforeContextMenuOpen"
                [contextMenuEventFunction]="contextMenuClicked"
                [isMemberField]="isCompoundFieldMember"
                [dataEntryMode]="dataEntryMode"
                [buttonId]="fieldOptionsId"
                [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
                [isInAccessibilityMode]="isInAccessibilityMode"
                [displayFieldOptions]="displayFieldOptions"
                [disableFieldOptions]="disableFieldOptions"
                [fieldAutomationId]="fieldAutomationId"
            lm-layout-util
                [hideWhiteSpace]="shouldHideWhiteSpace"
            soho-tooltip
                [popover]="true"
                [title]="popoverTitle"
                [placement]="'right'"
                [trigger]="'click'"

            (click)="onCompoundFieldClickEvent($event)"
            (focus)="onFocus($event)"
            (blur)="onBlur($event)"
            (contextmenu)="onContextMenu($event)"
            (focusin)="onFieldFocus($event)"
            (focusout)="onFieldBlur($event)"
        >
            @switch (displayType) {
                @case (layoutDisplayType.PLAIN) {
                    <input
                        #Input
                        [ngClass]="fieldClassesString"
                        [class.lm-uppercase]="isUpperCase"
                        [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                        [attr.id]="id"
                        [attr.bindId]="bindId"
                        [attr.aria-label]="(isCompoundFieldMember) ? (triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields) : field?.label?.nolabel && alternativeAriaLabel"
                        [attr.type]="type"
                        [attr.maxlength]="maxLength"
                        [attr.size]="size"
                        [attr.readOnly]="(readOnly$ | async) ? true : null"
                        [attr.tabindex]="isInAccessibilityMode ? null : (readOnly$ | async) ? -1 : null"
                        [attr.aria-describedby]="fieldDescriptionId" 
                        [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                        (ngModelChange)="onNgModelChange($event)"
                        lm-field-style
                        [specField]="specField"
                        [recalculateStyles]="triggerValueChange | async"
                        soho-input [fireInputEventKludge]="false"
                        soho-alert
                        soho-trackdirty
                        [searchForm]="onSearchForm"
                        (dirty)="onDirty($event)"
                        (pristine)="onPristine($event)"
                        (afterResetDirty)="onAfterResetDirty($event)"
                        soho-input-validate
                        (error)="onError($event)"
                        (valid)="onValid($event)"
                        (blur)="onBlur($event)"
                        (input)="onInput($event)"
                    />
                }
                @case (layoutDisplayType.MASK) {
                    <input
                       #Input
                       [ngClass]="fieldClassesString"
                       [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                       [attr.id]="id"
                       [attr.bindId]="bindId"
                       [attr.aria-label]="(isCompoundFieldMember) ? (triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields) : field?.label?.nolabel && alternativeAriaLabel"
                       [attr.type]="type"
                       [attr.size]="size"
                       [attr.readOnly]="(readOnly$ | async) ? true : null"
                       [attr.tabindex]="isInAccessibilityMode ? 0 : (readOnly$ | async) ? -1 : null"
                       [attr.aria-describedby]="fieldDescriptionId"
                       [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                       (ngModelChange)="onNgModelChange($event)"
                       lm-field-style
                       [specField]="specField"
                       [recalculateStyles]="triggerValueChange | async"
                       soho-input
                       [fireInputEventKludge]="false"
                       soho-alert
                       soho-trackdirty
                       [searchForm]="onSearchForm"
                       (dirty)="onDirty($event)"
                       (pristine)="onPristine($event)"
                       (afterResetDirty)="onAfterResetDirty($event)"
                       soho-input-validate
                       (error)="onError($event)"
                       (valid)="onValid($event)"
                       soho-mask
                       [options]="maskOptions"
                       (blur)="onBlur($event)"
                       (input)="onInput($event)"
                    />
                }

                @case (layoutDisplayType.PLAIN_FORM_TEXT) {
                    @if (layoutObject.icon) {
                        @if (validSohoIcon) {
                            <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
                                <use [attr.xlink:href]="'#icon-' +  layoutObject.icon + ''"></use>
                            </svg>
                        } @else {
                            <img class="icon" src="{{iconUrl}}" alt="">
                        }
                    }
                    @switch (hasRichTextVars) {
                        @case (true) {
                            <div class="editor-container is-preview field">
                                <div
                                    class="lm-richtext-content is-preview hide-white-space"
                                    [ngClass]="fieldClassesString"
                                    [attr.name]="id"
                                    [attr.id]="id"
                                    [attr.bindId]="bindId"
                                    data-options="{preview: true}"
                                    [innerHTML]="triggerValueChange | async | formatMessageRule:true:field.text:model:specFields"
                                    soho-editor
                                    soho-alert
                                ></div>
                            </div>
                        }
                        @case (false) {
                            <p
                               [attr.id]="id"
                               class="lm-form-text hide-white-space"
                               [class.personalize-text]="personalize && !layoutObject?.textStyle?.color"
                               [class.data]="true"
                               lm-text-style
                               [textStyle]="layoutObject?.textStyle"
                               [recalculateStyles]="triggerValueChange | async"
                            >{{triggerValueChange | async | formatMessageRule:true:field.text:model:specFields}}</p>
                        }
                    }
                }

                @case (layoutDisplayType.HTTP_FORM_TEXT) {
                    <lm-hyperlink
                        [attr.id]="id"
                        [specFields]="specFields"
                        [model]="model"
                        [layoutObject]="layoutObject"
                        [layoutInfo]="layoutInfo"
                        soho-alert
                        (fieldEvent)="onFieldEvent($event)"
                    >
                    </lm-hyperlink>
                }

                @case (layoutDisplayType.DISPLAY_AS_TAG) {
                    @if (layoutObject.icon) {
                        @if (validSohoIcon) {
                            <svg
                                class="icon"
                                focusable="false"
                                aria-hidden="true"
                                role="presentation"
                            >
                                <use [attr.xlink:href]="'#icon-' +  layoutObject.icon + ''"></use>
                            </svg>
                        } @else {
                            <img class="icon" src="{{iconUrl}}" alt="">
                        }
                    }

                    <div
                        class="tag-container"
                        soho-alert
                        lm-field-style
                        [fieldStyle]="layoutObject?.fieldStyle"
                        [specField]="specField"
                        [recalculateStyles]="triggerValueChange | async"
                    >
                        <!-- GenAI Generated code - Start -->
                        @if (maskActive$ | async) {
                        <!-- GenAI Generated code - End -->
                            <div class="lm-reveal-container" soho-revealable-text-mask [revealTextSettings]="{ revealCharacters: showLastNumberOfCharacters, revealBtn: 'icon' }">
                                <span
                                    [attr.id]="id"
                                    class="tag is-dismissible data"
                                    [ngClass]="{'is-active': isFieldTagFocused, 'is-focused': isFieldTagFocused, 'hide-focus': !isFieldTagFocused}"
                                    [ngStyle]="{'display': 'inline-block', 'outline': 'none'}"
                                    lm-field-style
                                        [fieldStyle]="tagStyle?.style"
                                        [isTag]="true"
                                        [recalculateStyles]="triggerValueChange | async"
                                        [attr.tabindex]="isInAccessibilityMode ? 0 : null"
                                    (focus)="onTagFocus()"
                                    (blur)="onTagBlur()"
                                >@if (isFormText) {{{triggerValueChange | async | formatMessageRule:true:field.text:model:specFields}}} @else {{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}}</span>
                            </div>
                        } @else {
                            <span
                                [attr.id]="id"
                                class="tag is-dismissible data"
                                [ngClass]="{'is-active': isFieldTagFocused, 'is-focused': isFieldTagFocused, 'hide-focus': !isFieldTagFocused}"
                                [ngStyle]="{'display': 'inline-block', 'outline': 'none'}"

                                lm-field-style
                                    [fieldStyle]="tagStyle?.style"
                                    [isTag]="true"
                                    [recalculateStyles]="triggerValueChange | async"

                                [attr.tabindex]="isInAccessibilityMode ? 0 : null"
                                (focus)="onTagFocus()"
                                (blur)="onTagBlur()"
                                >@if (isFormText) {{{triggerValueChange | async | formatMessageRule:true:field.text:model:specFields}}} @else {{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}}</span>
                        }
                    </div>
                }

                @case (layoutDisplayType.DISPLAY_AS_TEXT) {
                    <!-- GenAI Generated code - Start -->
                    @if (maskActive$ | async) {
                    <!-- GenAI Generated code - End -->
                            <div class="lm-reveal-container" soho-revealable-text-mask [revealTextSettings]="{ revealCharacters: showLastNumberOfCharacters, revealBtn: 'icon' }">
                                <span
                                    [attr.id]="id"
                                    class="lm-text-data hide-white-space data"
                                    [class.personalize-text]="personalize && !layoutObject?.fieldStyle?.color"

                                    lm-field-style
                                        [displayAsText]="true"
                                        [fieldStyle]="layoutObject?.fieldStyle"
                                        [specField]="specField"
                                        [recalculateStyles]="triggerValueChange | async"
                                >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</span>
                            </div>
                    } @else {
                        <p
                            [attr.id]="id"
                            class="lm-text-data hide-white-space"
                            [class.personalize-text]="personalize && !layoutObject?.fieldStyle?.color"
                            [ngStyle]="{'display': 'inline-block', '-webkit-line-clamp': layoutObject?.lines }"
                            [class.data]="true"
                            soho-alert
                            lm-field-style
                            [displayAsText]="true"
                            [fieldStyle]="layoutObject?.fieldStyle"
                            [specField]="specField"
                            [recalculateStyles]="triggerValueChange | async"
                        >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
                    }
                }
            }

            @if (isCompoundFieldMember) {
                @if(isPreviewCompoundMember) {
                    <ng-container *ngTemplateOutlet="previewMode"></ng-container>
                } @else {
                    <ng-container *ngTemplateOutlet="normalMode"></ng-container>
                }
            }
        </div>

        @if (field.type === 'compactFormat') {
            <button
                id="CompactForm"
                class="lm-compound-field-dialog-button"
                soho-button="btn-icon"
                [icon]="'launch'"
                soho-tooltip
                [content]="launchButtonTooltip"
                (click)="openCompactDialog($event)"
            ></button>
        }
    }
}

<ng-template #normalMode>
    @if (dirtyCompoundField) {
        <span class="icon-dirty lm-compound-member-field-dirty"></span>
    }
    @if (!(modelField.value | isBlankValue:specField)) {
        <p
            [attr.id]="id + '-text'"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            class="lm-compound-text hide-white-space"
            [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
            [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
            soho-tooltip
            [content]="triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields"
            soho-alert
            (focus)="onFocus($event)"
        >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
    } @else {
        <p
            [attr.id]="id + '-text'"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
            [ngClass]="{'lm-compound-text preview-placeholder': true, 'input-style is-placeholder': !(readOnly$ | async)}"
            [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
            soho-tooltip
            [content]="showLabel ? '' : triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields"
            soho-alert
            (focus)="onFocus($event)"
        >{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
    }
</ng-template>
<ng-template #previewMode>
    @if (!(modelField.value | isBlankValue:specField)) {
        <p
            [attr.id]="id + '-text'"
            class="lm-compound-text hide-white-space"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            [ngStyle]="{'display': 'inline-block', 'vertical-align': 'unset'}"
            soho-alert
        >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
    } @else {
        <p
            [attr.id]="id + '-text'"
            class="lm-compound-text input-style is-placeholder preview-placeholder"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
            soho-tooltip
            [content]="showLabel ? '' : triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields"
            soho-alert
        >{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
    }
</ng-template>

<ng-template #mouseOverTextTemplate>
    @if (layoutObject.mouseOverText) {
        <lm-mouse-over-text [beforeShowTooltip]="displayMouseOverText"></lm-mouse-over-text>
    }
</ng-template>

<span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>
@if (errorLiveMessage.liveMessage) {
    <span lm-live-region [liveRegionConfig]="errorLiveMessage"></span>
}